<script setup lang="ts">
import type { EsProduct } from '~/types/elastic'
import { vOnClickOutside } from '@vueuse/components'

const { product } = defineProps<{
  product: EsProduct
}>()

const prices = computed(() => {
  if (product.fromPrice) {
    return {
      regularPrice: product.fromPrice,
      finalPrice: product.fromPrice,
    }
  }
  return {
    regularPrice: product.regularPrice,
    finalPrice: product.finalPrice,
  }
})

const isOpen = ref(false)
</script>

<template>
  <div
    v-if="product?.name"
    v-on-click-outside="() => isOpen = false"
    class="shop-the-look-product"
    :class="{ 'shop-the-look-product--open': isOpen }"
  >
    <button
      type="button"
      class="shop-the-look-product__button"
      @click="isOpen = !isOpen"
    >
      <img
        class="shop-the-look-product__img"
        :src="useXcdnImage(product?.image, 'f=rs:fit:96')"
        :alt="product?.name"
        loading="lazy"
        fetchpriority="low"
        decoding="async"
      >
    </button>

    <div
      class="shop-the-look-product__panel"
      :aria-hidden="isOpen ? 'false' : 'true'"
    >
      <div class="shop-the-look-product__info">
        <div class="shop-the-look-product__name">
          {{ product?.name }}
        </div>

        <UiPrice
          class="shop-the-look-product__price"
          :prices="prices"
        >
          <template
            v-if="product.fromPrice"
            #prefix
          >
            v.a.
          </template>
        </UiPrice>
      </div>

      <button
        type="button"
        class="shop-the-look-product__close"
        @click="isOpen = false"
      >
        <span>{{ $t('Close') }}</span>
        <Icon name="icon:close" />
      </button>

      <div class="shop-the-look-product__actions">
        <ProductToggleWishlist
          class="shop-the-look-product__wishlist"
          :product="product"
          style="

--index: 0;"
        />

        <AppLink
          :to="product?.url"
          class="shop-the-look-product__link"
          style="

--index: 1;"
        >
          <span>{{ $t('View Product') }}</span>
          <Icon name="icon:arrow" />
        </AppLink>
      </div>
    </div>
  </div>
</template>

<style>
@import url("~layers/app/components/ShopTheLook/Product.css");
</style>
